import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { EmployeeProvider, useEmployee } from "@/context/EmployeeContext";
import EmployeeLogin from "@/components/EmployeeLogin";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import History from "@/pages/History";
import AdminDashboard from "@/pages/AdminDashboard";
import Layout from "@/components/Layout";
import AdminLayout from "@/components/AdminLayout";

const AppContent = () => {
  const { employee, login } = useEmployee();

  if (!employee) {
    return <EmployeeLogin onLogin={login} />;
  }

  // Show admin interface for admin users
  if (employee.isAdmin) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
          </Route>
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="projects" element={<Projects />} />
          <Route path="history" element={<History />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

function App() {
  return (
    <div className="zeitflow-container">
      <EmployeeProvider>
        <AppContent />
        <Toaster position="bottom-right" richColors />
      </EmployeeProvider>
    </div>
  );
}

export default App;
